import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Hero } from "./component/Hero";
import { Brands } from "./component/Brands";
import { Meet } from "./component/Meet";
import { MeetOld } from "./component/MeetOld";
import { Approch } from "./component/Approch";
import { Founders } from "./component/Founders";
import { CoFounder } from "./component/CoFounder";
import { CustomSlider } from "./component/CustomSlider";
import { FAQ } from "./component/FAQ";
import Join from "./component/Join";
import { News } from "./component/News";
import { Footer } from "./component/Footer";
import { Privacy } from "./component/Privacy";
import { Contact } from "./component/Contact";
import { Crypto } from "./component/Crypto";
import { Partner } from "./component/Partner";
import { Ecosystem } from "./component/PlatFormEcoSystem";
import BannerSlider from "./component/Banner";
function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      easing: "ease-in-out",
      offset: 0,
      delay: 100,
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div>
                <Hero />
              </div>
              <div>
                <Partner />
              </div>
              <div id="about">
                <Meet />
              </div>
              {/* <div id="about">
                <MeetOld />
              </div> */}
              <div id="features">
                <Approch />
              </div>
              <div data-aos="fade-up" data-aos-delay="300">
                <Ecosystem />
              </div>
              <div>
                <Join />
              </div>

              <div>
                <Founders />
              </div>
              <div data-aos="fade-up" data-aos-delay="300">
                <CoFounder />
                {/* <BannerSlider/> */}
              </div>
              <div data-aos="fade-up" data-aos-delay="100">
                <Brands />
                {/* <BannerSlider/> */}
              </div>
              <div>
                <Crypto />
              </div>
              <div>
                <Contact />
              </div>
              {/* <div data-aos="zoom-in" data-aos-delay="200">
                <CustomSlider />
              </div> */}
              {/* <div data-aos="fade-up" data-aos-delay="200">
                <FAQ />
              </div> */}

              {/* <div>
                <Contact />
              </div> */}

              <div>
                <Footer />
              </div>
            </>
          }
        />
        <Route
          path="/privacy"
          element={
            <>
              <Privacy />
              <Footer />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <Contact />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
